module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-input-money"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled
    },
    on: {
      "focus": _vm.focus,
      "blur": _vm.blur
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  }, [_c('span', {
    staticClass: "prefix",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  }, [_vm._t("prefix")], 2)]), _vm._v(" "), (!_vm.disabled) ? _c('rt-icon', {
    attrs: {
      "name": "rt-base-edit",
      "color": "#a9c2e8"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-460f522c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/form/rtInputMoney.vue
// module id = 1502
// module chunks = 124